/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SipCallSipConnectedPathParameters } from 'api/actions/sip-call-sip-connected/sip-call-sip-connected-path-parameters';
import { SipCallSipConnectedResponse } from 'api/actions/sip-call-sip-connected/sip-call-sip-connected-response';

type SipCallSipConnectedQueryParameters = Record<string, any>;

/**
 * The path of the SipCallSipConnected action.
 */
export const sipCallSipConnectedActionPath = new SweetPath<keyof SipCallSipConnectedPathParameters>(
  '/sip/call/{id}/sip-connected',
  { path: '{param}' }
);

/**
 * Creates a contextualized SipCallSipConnected actions.
 */
export default function createSipCallSipConnectedAction(axios: AxiosInstance) {
  return function sipCallSipConnectedAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: SipCallSipConnectedPathParameters;
    query?: SipCallSipConnectedQueryParameters;
  }) {
    const path = sipCallSipConnectedActionPath.insert(parameters);

    return axios.post<SipCallSipConnectedResponse, SipCallSipConnectedResponse>(path, { params: query, headers });
  };
}
